export default __webpack_public_path__ + "static/object-tile-anatomy-dark-d2007eeadbec7fe6859a840b9962a553cadcc20ebc5656617bdd3b3a11db6e82.png";